import { h } from 'preact'

import { useEffect, useRef } from 'preact/hooks'
import { createPortal } from 'preact/compat'

import ModalPortal from './ModalPortal'
import * as ariaAppHider from './helpers/ariaAppHider'

const Modal = (props) => {
  const node = useRef()

  useEffect(() => {
    document.body.appendChild(node.current)
    return () => {
      document.body.removeChild(node.current)
    }
  }, [])

  if (!node.current) {
    node.current = document.createElement('div')
    node.current.className = 'modal-portal'
  }

  return createPortal(<ModalPortal {...props} />, node.current)
}

Modal.setAppElement = (element) => {
  ariaAppHider.setElement(element)
}

export default Modal
